import { PALETTE } from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";

export default MediaQueryStyleSheet.create({
  row: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 15,
    marginLeft:10,
    marginRight:10,
  },
  listRow: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 15,
  },
  seperationBdr: {
    borderWidth: 0.5,
    borderColor: PALETTE.primaryStrokeLine,
    height: 1
  },
  seperationBdrView:{
    paddingVertical:20,
  },
  groupSelection: {
    paddingTop: 20,
    paddingBottom: 0,
    paddingLeft: 10,
    paddingRight: 10,
  },
  DateSelectionBar:{
    paddingHorizontal: 10,
  },
  textAligning:{
    // textAlign: 'center',
    marginTop:10
  },
  empty:{
    textAlign: 'center',
    marginTop:10
  },
  currencyText:{
    textAlign:'right'
  },
  loadingIndicator: {
    marginTop: 20
  },
  rightPadding:{
    paddingRight: 6
  }
},
);
